<div class="sidebar-container">
    <div class="sidebar-brand">
        <img src="assets/logo_corecredit_2.png" alt="CoreCredit" class="sidebar-brand__logo" width="152" height="40"
            loading="eager" />
        <p class="sidebar-brand__subtitle">Portal Personas</p>
    </div>

    <nav class="sidebar-nav" aria-label="Secciones">
        @for (item of menuItems; track item.link) {
        <a [routerLink]="item.link" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }" class="sidebar-nav-link">
            <span class="sidebar-nav-link__icon-box" aria-hidden="true">
                <fa-icon [icon]="icons[item.icon]" class="sidebar-nav-link__fa"></fa-icon>
            </span>
            <span class="sidebar-nav-link__label">{{ item.label }}</span>
            @if (item.showDot) {
            <span class="sidebar-nav-dot" aria-hidden="true"></span>
            }
        </a>
        }

        <a [href]="soporteMail" class="sidebar-nav-link sidebar-nav-link--external">
            <span class="sidebar-nav-link__icon-box" aria-hidden="true">
                <fa-icon [icon]="icons.falLifeRing" class="sidebar-nav-link__fa"></fa-icon>
            </span>
            <span class="sidebar-nav-link__label">Soporte</span>
        </a>
    </nav>

    <div class="sidebar-footer">
        <button type="button" class="sidebar-logout" (click)="logout()">
            <span class="sidebar-logout__icon-box" aria-hidden="true">
                <fa-icon [icon]="icons.fasPowerOff" class="sidebar-logout__icon" />
            </span>
            <span class="sidebar-logout__label">Cerrar sesión</span>
        </button>
    </div>
</div>
